import React from 'react';
import { Paper, InputBase, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Search as SearchIcon } from '@mui/icons-material';
import { defineMessages, useIntl } from 'react-intl';
import useMap from './useMap';
const msgs = defineMessages({
    inputSearchPlaceholder: {
        id: 'map.MapSearchBox.input.searchPlaceholder',
        defaultMessage: 'Search a location (e.g. New York or Tokyo)',
    },
});
function MapSearchBox() {
    const { loaded, setCenter } = useMap();
    const intl = useIntl();
    const theme = useTheme();
    const [query, setQuery] = React.useState('');
    const onSearch = React.useCallback(() => {
        if (!loaded) {
            return;
        }
        const text = query.trim();
        if (!text) {
            return;
        }
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: text }, (results, status) => {
            if (status !== google.maps.GeocoderStatus.OK) {
                return;
            }
            const loc = results?.at(0)?.geometry?.location;
            if (!loc) {
                return;
            }
            setCenter?.({ lat: loc.lat(), lng: loc.lng() });
        });
    }, [loaded, query, setCenter]);
    return (React.createElement(Paper, { variant: "outlined", sx: { display: 'flex', borderColor: theme.palette.action.disabled } },
        React.createElement(InputBase, { type: "search", value: query, onChange: (e) => setQuery(e.target.value), onKeyDown: (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    onSearch();
                }
            }, sx: {
                flex: 1,
                px: 1,
                py: 0,
                color: theme.palette.text.primary,
                '& .MuiInputBase-input': {
                    py: '0 !important',
                },
                '& .MuiInputBase-input::placeholder': {
                    opacity: 0.9,
                },
            }, placeholder: intl.formatMessage(msgs.inputSearchPlaceholder), inputProps: { 'aria-label': 'search ' } }),
        React.createElement(IconButton, { type: "button", "aria-label": "search", onClick: onSearch },
            React.createElement(SearchIcon, { fontSize: "small" }))));
}
export default MapSearchBox;
